import { Deserializable } from "../interfaces/deserialize";
import * as _ from "lodash";

export class PackModel implements Deserializable {
	_id?: string;
	name!: string;
	product!: string;
	licenseType!: string[] | undefined;
	type!: string;
	typeDevice!: string;
	typeWashMachine!: string;
	trial!: {
		hasTrial: boolean;
		durationAmount?: number;
		durationUnit?: string;
	};
	ekonMainId?: string;
	ekonRenewalId?: string;
	paymentType!: string;
	subscriptionAmountDevice!: number;
	subscriptionAmountWashMachine!: number;
	subscriptionAmount!: number;
	subscriptionUnit!: string;
	licenceNumber!: string;
	packPrice: Array<{ amount: string; currency: string }> = [];
	renovationPrice: Array<{ amount: string; currency: string }> = [];
	createdAt?: string;
	updatedAt?: string;

	deserialize(obj: any) {
		Object.assign(this, obj);
		return this;
	}

	public getLicenceNumber(): number {
		if (this.licenceNumber !== undefined) {
			return Number(this.licenceNumber);
		}
		return 0;
	}

	public getPrice(): string {
		if (this.packPrice && Array.isArray(this.packPrice) && this.packPrice.length > 0) {
			return this.packPrice[0] && this.packPrice[0] !== undefined ? this.packPrice[0].amount : "0";
		}
		return "0";
	}

	public getRenovationPrice(): string {
		if (this.renovationPrice && Array.isArray(this.renovationPrice) && this.renovationPrice.length > 0) {
			return this.renovationPrice[0] && this.renovationPrice[0] !== undefined ? this.renovationPrice[0].amount : "0";
		}
		return "0";
	}

	public getCurrency(): string {
		return "€";
	}

	public getName(): string {
		return this.name ? this.name : "";
	}

	public deserializeObje(pack: PackModel) {
		return {
			packId: pack._id,
			amount: 1,
		};
	}

	public eDPremium(packs: PackModel[]): any[] {
		let packPremium = [];
		const core = packs.find((pack) => pack.type === "core");
		const additional = packs.find((pack) => pack.type === "additional");
		if (core && additional) {
			packPremium.push(this.deserializeObje(core));
			packPremium.push(this.deserializeObje(additional));
			return packPremium;
		}
	}
}
